import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Center from "../common/components/Center";
import HorizontalSlider from "../common/components/HorizontalSlider";
import { identityIndependence } from "../features/listenerProfile";
import VerticalCenter from "../common/components/VerticalCenter";
import Padding from "../common/components/Padding";

export default function Question2IdentityIndependence() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <Padding>
        <Center>
          <h1>
            {t(
              "Is preserving your identity and independence more important than maintaining relationships?"
            )}
          </h1>
        </Center>
      </Padding>
      <VerticalCenter>
        <HorizontalSlider
          leftElement={<p>{t("That's me")}</p>}
          values={[1, 2.33, 3.66, 5]}
          defaultValue={2.33}
          onChange={(value) => dispatch(identityIndependence(value))}
          rightElement={<p>{t("That's not me")}</p>}
        />
      </VerticalCenter>
    </>
  );
}
